module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "content-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileSelected),
      expression: "profileSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profileSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeProfile]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _vm._l((_vm.profiles), function(profile, membershipId) {
    return [_c('option', {
      domProps: {
        "value": profile.profile.membershipType
      }
    }, [_vm._v(_vm._s(_vm.getMembershipTypeName(profile.profile.membershipType)))])]
  })], 2), _vm._v(" "), _vm._l((_vm.items), function(category) {
    return _c('div', {
      staticClass: "table-cell"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          _vm.toggleSection(category)
        }
      }
    }, [_vm._v(_vm._s(category.name) + "\n\t\t\t\t"), _c('span', [_vm._v("Click to toggle")])]), _vm._v(" "), _vm._l((category.missing), function(item) {
      return [_c('v-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('item-node', {
        staticClass: "tooltip-target",
        attrs: {
          "data": item,
          "className": {
            acquired: item.acquired
          }
        }
      }), _vm._v(" "), _c('template', {
        staticClass: "popper",
        attrs: {
          "slot": "popover"
        },
        slot: "popover"
      }, [_c('tooltip', {
        attrs: {
          "data": item,
          "item-def": item,
          "type": 'item'
        }
      })], 1)], 2)]
    }), _vm._v(" "), _vm._l((category.discovered), function(item) {
      return [_c('v-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('item-node', {
        staticClass: "tooltip-target",
        attrs: {
          "data": item,
          "className": {
            acquired: item.acquired
          }
        }
      }), _vm._v(" "), _c('template', {
        staticClass: "popper",
        attrs: {
          "slot": "popover"
        },
        slot: "popover"
      }, [_c('tooltip', {
        attrs: {
          "data": item,
          "item-def": item,
          "type": 'item'
        }
      })], 1)], 2)]
    })], 2)
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6096a879", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6096a879","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Collection.vue
// module id = 57
// module chunks = 0 1